import Base from "../base";
import { OfficeHistoryMail } from "./officeHistoryMail";
import { OfficeHistorySameBuilding } from "./officeHistorySameBuilding";
import { OfficeHistoryOverTherapistVisitCount } from "./officeHistoryOverTherapistVisitCount";
import { OfficeHistoryOverTherapistTargetAddition } from "./officeHistoryOverTherapistTargetAddition";
import { OfficeHistorySingleBuildingCount } from "./officeHistorySingleBuildingCount";

//事業所履歴
export interface OfficeHistory extends Base {
  /** ID */ id: number;
  /** 事業所ID */ office_id: number;
  /** 開始日 */ start_date: string;
  /** 終了日 */ end_date: string;
  /** 事業所名 */ name: string;
  /** 事業所名(審査支払機関に届け出た名称) */ name_notification: string;
  /** 郵便番号 */ post_code: string;
  /** 都道府県 */ pref: number;
  /** 市区 */ city: string;
  /** 町村番地 */ area: string;
  /** 建物 */ building: string;
  /** 市外局番 */ tel_area: string;
  /** 市内局番 */ tel_city: string;
  /** 加入者番号 */ tel_num: string;
  /** 市外局番 */ fax_area: string;
  /** 市内局番 */ fax_city: string;
  /** 加入者番号 */ fax_num: string;
  /** 医療機関コード */ medical_institution_code: string;
  /** 事業所番号 */ office_code: string;
  /** 適格請求書用登録番号(iBowレセプト利用者請求で出力) */ invoice_no: string;
  /** 介護サービス提供 0:なし 1:あり */ is_care_service: number;
  /** 事業区分 0:未選択 1:指定 2:基準該当 3:みなし指定 */ business_div: number;
  /** 地域区分 0:未選択 1:1級 2:2級 3:3級 4:4級 5:5級 6:6級 7:7級 8:その他 */ area_div: number;
  /** 日々の褥瘡評価設定自立度 0:未選択 1:J1 2:J2 3:A1 4:A2 5:B1 6:B2 7:C1 8:C2 */ jokuso_rate_div: number;
  /** 医師に対する敬称 0:未選択 1:先生 2:先生 御待史 3:先生 御侍史 4:先生 御机下 */ doctor_title_div: number;
  /** シフト管理機能表示設定 0:表示しない 1:表示する */ is_shift: number;
  /** 訪問予定管理機能表示設定 0:表示しない 1:表示する */ is_visit_schedule_management_enabled: number;
  /** 20分超えのリハ記録書IIまとめ設定 1:20分を超えた時、記録書Ⅱを1枚にまとめる。 2:20分毎に記録書Ⅱを作成する。 */ record_divide_div: number;
  /** 職員リスト表示設定 1:在職／休職／退職を表示 2:在職／休職を表示 3:在職のみ表示 */ staff_list_div: number;
  /** 月次報告書表示設定 0:サービス訪問（自費）記録を報告書に記載しない 1:サービス訪問（自費）記録を報告書に記載する */ service_record_disp_div: number;
  /** 観察項目設定区分 0:観察項目最大21項目とし、記録書Ⅱ（カルテ部分）をA4１枚に収める 1:観察項目の登録数制限を解除する（観察項目カテゴリ表示） */ adl_setting_div: number;
  /** 利用者メッセージボードロック時間（秒） */ patient_msg_board_time: number;
  /** 銀行名 */ bank_name: string;
  /** 支店名 */ branch_name: string;
  /** 口座種別 */ account_kind: string;
  /** 口座番号 */ account_num: string;
  /** 口座名義 */ account_name: string;
  /** 介護_介護訪問提供時間必須フラグ 0:必須にしない 1:必須にする */ care_service_time_required: number;
  /** 介護_定期巡回サービス提供 0:なし 1:あり */ care_regular_visit_service_exist: number;
  /** 介護_特別地域加算 0:なし 1:あり */ care_special_area_div: number;
  /** 介護_緊急時訪問看護加算 0:加算なし 1:加算あり */ care_kinkyu_houmon_add: number;
  /** 介護_特別管理体制加算 0:加算なし 1:特別管理Ⅰ 2:特別管理Ⅱ */ care_tokubetsu_kanri_add: number;
  /** 介護_ターミナルケア加算 0:加算なし 1:加算あり */ care_terminal_care_add: number;
  /** 介護_サービス提供体制強化加算 0:加算なし 1:加算あり */ care_service_supply_add: number;
  /** 介護_専門看護師 0:なし 1:あり */ care_is_senmon_kangoshi: number;
  /** 介護_中山間地域等居住者提供加算 0:加算なし 1:加算あり */ care_small_office_area_add: number;
  /** 介護_中山間地域等小規模事業所加算 0:加算なし 1:加算あり */ care_small_office_scale_add: number;
  /** 介護_看護体制強化加算 0:加算なし 1:加算Ⅱ(300単位)あり(介護・予防) 2:加算Ⅱ(300単位)あり(予防のみ) 3:加算Ⅱ(300単位)あり(介護のみ) 4:加算Ⅰ(600単位)あり(介護のみ) 5:加算Ⅰ(600単位)介護あり、加算Ⅱ(300単位)予防あり */ care_kyoka_add: number;
  /** 介護_同一建物に居住する利用者の減算 0:なし 1:あり */ care_riyousya_gensan: number;
  /** 介護_ほのぼの連携:サービス提供終了時刻を連携時に含めるか含めないかの区分 2:含めない 1:含める 0:Ⅰ5は＋1分しない、Ⅰ5以外は+1分する */ care_end_time_include_div: number;
  /** 介護_高齢虐待防止未実施減算 0:なし 1:あり */ care_elderly_abuse_prevention_gensan: number;
  /** 介護_口腔連携強化加算 0:加算なし 1:加算あり */ care_mouth_renkei_kyoka_add: number;
  /** 介護_リハ職超過フラグ 0:なし 1:あり */ care_over_therapist_visit_count_flg: number;
  /** 介護_対象加算なし(6月) 0:対象加算あり 1:対象加算なし */ care_over_therapist_no_additions_flg: number;
  /** 介護_対象加算なし(7月) 0:対象加算あり 1:対象加算なし */ care_over_therapist_no_additions_july_flg: number;
  /** 介護_事業継続計画未策定減算 0:なし 1:あり */ care_bcp_gensan: number;
  /** 介護_介護職員等処遇改善加算 0:なし 1:あり */ care_shogu_kaizen_add: number;
  /** 医療_緊急時訪問看護加算 0:加算なし 1:加算あり */ medical_kinkyu_houmon_kango_add: number;
  /** 医療_特別管理加算 0:加算なし 1:加算あり */ medical_tokubetsu_kanri_add: number;
  /** 医療_ターミナルケア加算 0:加算なし 1:加算あり */ medical_terminal_care_add: number;
  /** 医療_24時間対応加算 0:加算なし 1:加算あり */ medical_hour24_taiou_add: number;
  /** 医療_24時間連絡体制加算 0:加算なし 1:加算あり */ medical_hour24_renraku_add: number;
  /** 医療_専門看護師 0:なし 1:あり */ medical_is_senmon_kangoshi: number;
  /** 医療_精神科訪問看護基本療養費 0:なし 1:あり */ medical_is_seishin_kihon_ryouyouhi: number;
  /** 医療_包括型訪問看護療養費 0:なし 1:あり */ medical_comprehensive_flg: number;
  /** 同一建物ID(包括対象) */ comp_same_building_id: number;
  /** 同一建物グループID(包括対象) */ comp_same_building_group_id: number;
  /** 建物内24時間連絡体制 0:なし 1:あり */ is_building_with24h_contact: number;
  /** 医療_精神科複数回訪問加算 0:加算なし 1:加算あり */ medical_seishin_fukusukai_add: number;
  /** 医療_精神科重症患者早期集中支援管理連携加算 0:加算なし 1:加算あり */ medical_seishin_renkei_add: number;
  /** 医療_訪問看護管理療養費区分（2日目以降）1 1:管理療養費１ 2:管理療養費２ */ medical_kanri_ryouyouhi_div: number;
  /** 医療_機能強化型訪問看護管理療養費1 0:加算なし 1:加算あり */ medical_kinou_kyoka_ryouyouhi1: number;
  /** 医療_機能強化型訪問看護管理療養費2 0:加算なし 1:加算あり */ medical_kinou_kyoka_ryouyouhi2: number;
  /** 医療_機能強化型訪問看護管理療養費3 0:加算なし 1:加算あり */ medical_kinou_kyoka_ryouyouhi3: number;
  /** 医療_機能強化型訪問看護管理療養費4 0:加算なし 1:加算あり */ medical_kinou_kyoka_ryouyouhi4: number;
  /** 医療_同一日同一建物減算（記録提出時のチェック） 0:なし 1:あり */ medical_is_confirm_same_building_record2: number;
  /** 医療_24時間対応体制負担軽減の取組 0:なし 1:あり */ medical_is_hour24_taiou_reduce_burden: number;
  /** 医療_訪問看護医療DX情報活用加算 0:なし 1:あり */ medical_dx_info_util_add: number;
  /** 医療_訪問看護医療情報連携加算 0:なし 1:あり */ medical_info_collab_add: number;
  /** 医療_ベースアップ評価料（Ⅰ） 0:なし 1:あり */ medical_base_up1: number;
  /** 医療_ベースアップ評価料（Ⅱ） 0:なし 1~18:ベースアップ評価料（Ⅱ）1~18 */ medical_base_up2: number;
  /** 医療_訪問看護遠隔診療補助料 0:なし 1:あり */ medical_remote_support_div: number;
  /** 賃金改善フラグ 0:なし 1:(Ⅰ)(Ⅱ)継続あり 2:(Ⅰ)のみ継続あり */ wage_improvement_flg: number;
  /** 医療_特別地域対象（ステーション） 0:対象外 1:対象 */ medical_special_area_station_div: number;
  /** 医療_物価対応料 0:あり 1:なし */ medical_living_cost: number;
  /** 履歴コメント */ comment: string;
  /** 24時間体制並び順区分 1:古いものから順に表示 2:新しいものから順に表示 */ hour24_order_div: number;
  /** ワイズマン自機関番号 */ wiseman_office_id: number;
  /** ワイズマン連携利用者ID前0有効区分 0:,無効 1:有効 */ before0_patientid_div: number;
  /** すこやかサン連携CSV出力 公費情報の負担額デフォルトチェック状態 0:チェックなし 1:チェックあり すこやかサンをなくすかどうか協議中 */ sukoyaka_csv_self_bear_default_check: number;
  /** すこやかサン連携CSV出力 訪問看護療養費情報の心身の状態デフォルトチェック状態 0:チェックなし 1:チェックあり すこやかサンをなくすかどうか協議中 */ sukoyaka_csv_mind_body_state_default_check: number;
  /** 集金代行サービス利用フラグ 0:利用しない 1:利用する */ use_edi_flg: number;
  /** 委託者コード */ edi_code: string;
  /** 委託者名 */ edi_name: string;
  /** 振替区分 1:当月 2:翌月 */ transfer_div: number;
  /** 振替日 */ transfer_day: number;
  /** 開始日（和暦） */ start_date_wareki: string;
  /** 終了日（和暦） */ end_date_wareki: string;
  /** 更新日時（和暦） */ updated_at_wareki: string;
  /** メール */ office_history_mails: OfficeHistoryMail[];
  /** 同一建物 */ office_history_same_buildings: OfficeHistorySameBuilding[];
  /** 介護_理学療法士超過減算 リハ職訪問回数 */ office_history_over_therapist_visit_count: OfficeHistoryOverTherapistVisitCount[];
  /** 介護_理学療法士超過減算 対象加算 */ office_history_over_therapist_target_addition: OfficeHistoryOverTherapistTargetAddition[];
  /** コロナ対策区分（介護・医療共通） 0:なし 1:あり */ covid19_div: number;
  /** 押印区分 */ report_seel_div: number;
  /** 共有ファイル区分 */ shared_file_div: number;
  /** 訪問予定編集権限 0:開催者のみ 1:誰でも */ is_all_edit_visit_schedule: number;
  /** ケアプラン連携利用するかどうか */ is_careplan_used: number;
  /** 24時間体制コメント並び順区分 1:古いものから順に表示 2:新しいものから順に表示 */ hour24_comment_order_div: number;
  /** ヒヤリハット提出時、チャットにも通知を飛ばすかどうか */ notices_chat_occur_report_submitted: boolean;
  /** 利用者ファイル登録時、チャットにも通知を飛ばすかどうか */ notices_chat_patient_file_registered: boolean;
  /** 緯度 */ latitude: number;
  /** 経度 */ longitude: number;
  /** BI閲覧権限区分 0:事業所所長権限以上 1:事務所事務員権限以上 */ bi_auth_div: number;
  /** 幼児年齢上限設定 0〜6 */ infant_age_limit: number;
  /** 単一建物集計 */ office_history_single_building_counts: OfficeHistorySingleBuildingCount[];
}
export const setOfficeHistory = (): OfficeHistory => ({
  id: 0,
  office_id: 0,
  start_date: "",
  end_date: "",
  name: "",
  name_notification: "",
  post_code: "",
  pref: 0,
  city: "",
  area: "",
  building: "",
  tel_area: "",
  tel_city: "",
  tel_num: "",
  fax_area: "",
  fax_city: "",
  fax_num: "",
  medical_institution_code: "",
  office_code: "",
  invoice_no: "",
  is_care_service: 0,
  business_div: 0,
  area_div: 0,
  jokuso_rate_div: 0,
  doctor_title_div: 0,
  is_shift: 0,
  is_visit_schedule_management_enabled: 1,
  record_divide_div: 0,
  staff_list_div: 1,
  service_record_disp_div: 0,
  adl_setting_div: 0,
  patient_msg_board_time: 0,
  bank_name: "",
  branch_name: "",
  account_kind: "",
  account_num: "",
  account_name: "",
  care_service_time_required: 0,
  care_regular_visit_service_exist: 0,
  care_special_area_div: 0,
  care_kinkyu_houmon_add: 0,
  care_tokubetsu_kanri_add: 0,
  care_terminal_care_add: 0,
  care_service_supply_add: 0,
  care_is_senmon_kangoshi: 0,
  care_small_office_area_add: 0,
  care_small_office_scale_add: 0,
  care_kyoka_add: 0,
  care_riyousya_gensan: 0,
  care_end_time_include_div: 2,
  care_elderly_abuse_prevention_gensan: 0,
  care_mouth_renkei_kyoka_add: 0,
  care_over_therapist_visit_count_flg: 0,
  care_over_therapist_no_additions_flg: 0,
  care_over_therapist_no_additions_july_flg: 0,
  care_bcp_gensan: 0,
  care_shogu_kaizen_add: 0,
  medical_kinkyu_houmon_kango_add: 0,
  medical_tokubetsu_kanri_add: 0,
  medical_terminal_care_add: 0,
  medical_hour24_taiou_add: 0,
  medical_hour24_renraku_add: 0,
  medical_is_senmon_kangoshi: 0,
  medical_is_seishin_kihon_ryouyouhi: 0,
  medical_comprehensive_flg: 0,
  comp_same_building_id: 0,
  comp_same_building_group_id: 0,
  is_building_with24h_contact: 0,
  medical_seishin_fukusukai_add: 0,
  medical_seishin_renkei_add: 0,
  medical_kanri_ryouyouhi_div: 0,
  medical_kinou_kyoka_ryouyouhi1: 0,
  medical_kinou_kyoka_ryouyouhi2: 0,
  medical_kinou_kyoka_ryouyouhi3: 0,
  medical_kinou_kyoka_ryouyouhi4: 0,
  medical_is_confirm_same_building_record2: 0,
  medical_is_hour24_taiou_reduce_burden: 0,
  medical_dx_info_util_add: 0,
  medical_info_collab_add: 0,
  medical_base_up1: 0,
  medical_base_up2: 0,
  medical_remote_support_div: 0,
  wage_improvement_flg: 0,
  medical_special_area_station_div: 0,
  medical_living_cost: 0,
  comment: "",
  hour24_order_div: 0,
  wiseman_office_id: 0,
  before0_patientid_div: 0,
  sukoyaka_csv_self_bear_default_check: 0,
  sukoyaka_csv_mind_body_state_default_check: 0,
  use_edi_flg: 0,
  edi_code: "",
  edi_name: "",
  transfer_div: 0,
  transfer_day: 0,
  created_at: "",
  updated_at: "",
  deleted_at: "",
  start_date_wareki: "",
  end_date_wareki: "",
  updated_at_wareki: "",
  office_history_mails: [],
  office_history_same_buildings: [],
  office_history_over_therapist_visit_count: [],
  covid19_div: 0,
  report_seel_div: 0,
  shared_file_div: 0,
  is_all_edit_visit_schedule: 0,
  is_careplan_used: 1,
  hour24_comment_order_div: 0,
  notices_chat_occur_report_submitted: false,
  notices_chat_patient_file_registered: false,
  office_history_over_therapist_target_addition: [],
  latitude: 0,
  longitude: 0,
  bi_auth_div: 0,
  infant_age_limit: 3,
  office_history_single_building_counts: []
});
export const DefaultOfficeHistory = setOfficeHistory;
